'use client'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/lib/api'

const PUT_TENANT_MAINTENANCE_ENTER = '/tenants/maintenance/enter'

type EnterTenantMaintenanceParams = {
  lockVersion: number
}

export function useEnterTenantMaintenance() {
  return useMutation({
    mutationFn: async ({ lockVersion }: EnterTenantMaintenanceParams) => {
      const { data, error, response } = await client.PUT(PUT_TENANT_MAINTENANCE_ENTER, {
        body: {
          lockVersion,
        },
      })

      return {
        data,
        error,
        response,
      }
    },
  })
}
